
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign/[campaignId]",
      function () {
        return require("private-next-pages/campaign/[campaignId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign/[campaignId]"])
      });
    }
  